module.exports = __webpack_public_path__ + "static/media/Eco Verde 2.b763a8a6.jpg";